import { forwardRef } from 'react';

import { ListItemInput, ListItemInputProps } from './ListItemInput';
import { Checkbox, CheckboxProps } from '../checkbox/Checkbox';

export interface ListItemCheckboxProps extends Omit<ListItemInputProps, 'ref'> {
  /**
   * Props for the underlying input (checkbox)
   */
  inputProps?: CheckboxProps;
  /**
   * Ref for the underlying input
   */
  ref?: React.ForwardedRef<HTMLButtonElement>;
}

export const ListItemCheckbox = forwardRef<HTMLButtonElement, ListItemCheckboxProps>(
  ({ classNames = [], inputProps, ...props }: ListItemCheckboxProps, ref: ListItemCheckboxProps['ref']) => {
    const { ref: inputRef, ...otherProps } = props;
    return (
      <ListItemInput {...otherProps} classNames={classNames}>
        <Checkbox
          {...inputProps}
          ref={ref}
          id={props.id}
          name={props.id}
          checked={props.isSelected}
          onCheckedChange={() => props.handleClick(props.id)}
        />
      </ListItemInput>
    );
  },
);
ListItemCheckbox.displayName = 'ListItemCheckbox';
